import { PlaceholderPage } from './PlaceholderPage';

export const AlertsNotificationsPage = () => <PlaceholderPage title="Alerts & Notifications" />;
